import gql from 'graphql-tag';

export const limitBlockingFragment = gql`
  fragment LimitBlockingStatus on Limit {
    blockingStatus {
      configuredAt
      blocked
      initiatorType
      validFrom
    }
  }
`;

export const limitFragment = gql`
  fragment PeriodLimit on PeriodLimit {
    value
    available
    currentPeriodEndTime
    pendingPeriodLimit {
      configuredAt
      validFrom
      value
    }
    pendingPeriodLimitRemoval {
      validFrom
    }
    isDefault
  }
`;
